import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** Returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)

/** Returns Customer Limits
@return { Array }
*/
export const getCustomerLimits = state => state.customerLimits

/** Returns Customer Plafonds
@return { Array }
*/
export const getCustomerPlafonds = state => state.customerPlafonds

/** Returns Transfer Currencies List
@return { Array }
*/
export const getCurrenciesList = state => state.currenciesList

/** Returns Countries List
@return { Array }
*/
export const getCountriesList = state => state.countriesList

/** Returns Transfer Reasons List
@return { Array }
*/
export const getTransfersReasons = state => state.transfersReasons

/** Returns Operation Types List
@return { Array }
*/
export const getOperationTypesList = state => state.operationTypesList

/** Returns Categories List
@return { Array }
*/
export const getCategoriesList = state => state.categoriesList

/** Returns Transfers Expenses
@return { Array }
*/
export const getTransfersExpenses = state => state.transfersExpenses

/** Returns Payment Types List
@return { Array }
*/
export const getPaymentTypesList = state => state.paymentTypesList

/** Returns Profile Unmasked Info
@return { Array }
*/
export const getProfileUnmaskedInfo = state => state.profileUnmaskedInfo

 /** returns International Transfers Requests List
@return { Array }
*/
export const getTransfersRequestsList = state => {
    return state.transfersRequestsList
}

 /** returns International Transfers Requests List get more
@return { Array }
*/
export const getTransfersRequestsListHasMore = state => {
    return state.transfersRequestsListHasMore
}

/** returns Favorites List
@return { Array }
*/
export const getFavoritesList = state => {
    return state.favoritesList
}

/** returns Favorites hasMore value
@return { Boolean }
*/
export const getFavoritesListHasMore = state => state.favoritesHasMore
